import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getStudentCoins = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetStudentCoinsByStudentNumber/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getQuoteOfTheDay = async () => {
    try {
        const result = await axios.get('https://quotes.rest/qod?language=en');
        const quoteRes = JSON.parse(result.request.response);

        return {
            quote: quoteRes.contents.quotes[0].quote,
            author: quoteRes.contents.quotes[0].author
        }
    } catch (error) {
        console.error(error);
    }
}

export const submitFeedback = async (feedback) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}General/SendFeedback`,
        data: feedback,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getMonsterFoodCount = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetMonsterFoodCountByStudentNumber/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};
